import App from "./app.js";

export default App;
